module.exports = __webpack_public_path__ + "static/localization-4ebd6e8f8492210601b71d80ab91fdf6.png";